import React from 'react';
import type { IconProps } from '../types';

export const OHIFLogo = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="2in"
    height="0.5in"
    viewBox="0 0 3446 584"
  >
    <path
      id="Imported Path"
      fill="#36616d"
      stroke="black"
      stroke-width="1"
      d="M 3133.52,249.98
           C 3090.40,259.24 3056.03,292.75 3046.03,335.52
             3038.65,366.91 3043.53,400.30 3059.28,426.68
             3065.90,437.81 3081.65,454.82 3091.40,461.32
             3102.02,468.45 3116.90,475.20 3129.40,478.58
             3139.90,481.33 3144.40,481.83 3160.40,481.83
             3176.02,481.96 3181.02,481.46 3190.39,479.08
             3210.39,473.95 3230.77,462.82 3242.76,450.32
             3242.76,450.32 3247.64,445.32 3247.64,445.32
             3247.64,445.32 3254.64,451.57 3254.64,451.57
             3269.39,464.82 3289.89,475.20 3310.38,479.71
             3325.01,482.96 3355.76,482.71 3368.63,479.21
             3397.00,471.58 3417.25,452.32 3422.25,428.18
             3423.13,424.18 3423.50,414.80 3423.25,406.55
             3422.88,393.29 3422.50,391.29 3418.88,383.54
             3416.63,378.91 3412.00,372.03 3408.38,368.28
             3396.50,355.78 3382.75,349.02 3349.51,339.52
             3317.13,330.27 3307.26,324.01 3307.26,313.01
             3307.26,303.38 3315.01,297.38 3330.38,295.00
             3349.26,292.00 3369.88,298.38 3384.25,311.76
             3384.25,311.76 3391.75,318.76 3391.75,318.76
             3391.75,318.76 3407.63,302.88 3407.63,302.88
             3416.38,294.13 3423.50,286.37 3423.50,285.50
             3423.50,283.00 3412.13,271.37 3404.13,265.61
             3394.75,258.99 3383.50,253.73 3371.63,250.61
             3364.51,248.61 3358.63,248.23 3339.76,248.36
             3318.13,248.36 3316.01,248.61 3306.64,251.73
             3277.26,261.49 3260.64,281.12 3257.89,309.51
             3256.76,321.14 3258.89,335.02 3263.51,344.90
             3271.64,362.28 3290.26,374.16 3324.76,383.91
             3357.13,393.04 3368.76,398.67 3372.63,406.80
             3375.26,412.18 3375.26,416.43 3373.01,421.93
             3369.51,430.31 3357.01,435.19 3339.13,435.19
             3318.01,435.06 3299.39,428.18 3285.64,415.18
             3285.64,415.18 3277.89,407.80 3277.89,407.80
             3277.89,407.80 3262.01,423.68 3262.01,423.68
             3262.01,423.68 3246.01,439.56 3246.01,439.56
             3246.01,439.56 3230.64,424.18 3230.64,424.18
             3230.64,424.18 3215.27,408.80 3215.27,408.80
             3215.27,408.80 3212.77,411.55 3212.77,411.55
             3203.14,422.56 3184.27,430.93 3166.02,432.31
             3141.15,434.19 3116.77,421.68 3104.90,401.05
             3096.78,386.79 3093.78,364.03 3097.90,346.65
             3100.78,334.27 3105.77,325.39 3114.77,316.26
             3127.90,303.00 3141.27,297.63 3161.65,297.63
             3180.77,297.63 3197.52,303.63 3209.02,314.76
             3209.02,314.76 3215.02,320.51 3215.02,320.51
             3215.02,320.51 3232.02,303.50 3232.02,303.50
             3232.02,303.50 3248.89,286.62 3248.89,286.62
             3248.89,286.62 3246.76,283.37 3246.76,283.37
             3243.39,278.12 3226.52,265.36 3216.14,260.24
             3205.27,254.73 3193.64,250.86 3183.02,248.98
             3171.39,246.86 3145.77,247.48 3133.52,249.98 Z
           M 2879.92,248.86
           C 2839.79,257.36 2807.42,288.87 2796.05,330.77
             2792.67,343.27 2791.17,374.16 2793.42,387.17
             2801.30,432.69 2832.04,468.08 2873.42,479.21
             2885.04,482.33 2911.29,482.96 2922.91,480.33
             2937.66,477.08 2953.04,469.08 2964.16,458.82
             2964.16,458.82 2969.78,453.57 2969.78,453.57
             2969.78,453.57 2969.78,465.70 2969.78,465.70
             2969.78,465.70 2969.78,477.70 2969.78,477.70
             2969.78,477.70 2995.41,477.70 2995.41,477.70
             2995.41,477.70 3021.03,477.70 3021.03,477.70
             3021.03,477.70 3021.03,364.53 3021.03,364.53
             3021.03,364.53 3021.03,251.36 3021.03,251.36
             3021.03,251.36 2995.41,251.36 2995.41,251.36
             2995.41,251.36 2969.78,251.36 2969.78,251.36
             2969.78,251.36 2969.78,263.99 2969.78,263.99
             2969.78,263.99 2969.78,276.74 2969.78,276.74
             2969.78,276.74 2963.29,270.62 2963.29,270.62
             2954.54,262.36 2943.91,256.11 2931.66,251.86
             2922.91,248.86 2919.41,248.36 2903.54,248.11
             2893.54,247.86 2882.92,248.23 2879.92,248.86 Z
           M 2923.79,297.75
           C 2946.29,302.50 2964.28,320.51 2970.41,344.52
             2972.66,353.15 2972.91,373.41 2970.91,382.91
             2969.03,392.17 2962.16,406.05 2956.16,412.80
             2944.16,426.43 2928.91,433.06 2909.16,433.06
             2879.67,433.06 2858.79,417.93 2848.92,389.29
             2846.17,381.04 2845.54,377.41 2845.54,365.16
             2845.42,342.90 2851.42,327.27 2865.17,313.63
             2879.79,299.25 2901.91,293.25 2923.79,297.75 Z
           M 2652.31,249.61
           C 2640.56,252.11 2623.06,261.11 2613.94,269.49
             2613.94,269.49 2606.06,276.62 2606.06,276.62
             2606.06,276.62 2606.06,263.99 2606.06,263.99
             2606.06,263.99 2606.06,251.36 2606.06,251.36
             2606.06,251.36 2580.44,251.36 2580.44,251.36
             2580.44,251.36 2554.81,251.36 2554.81,251.36
             2554.81,251.36 2554.81,411.43 2554.81,411.43
             2554.81,411.43 2554.81,571.49 2554.81,571.49
             2554.81,571.49 2580.44,571.49 2580.44,571.49
             2580.44,571.49 2606.06,571.49 2606.06,571.49
             2606.06,571.49 2606.06,513.34 2606.06,513.34
             2606.06,481.33 2606.31,455.19 2606.69,455.19
             2607.06,455.19 2610.94,458.07 2615.19,461.70
             2623.81,468.83 2639.18,476.70 2650.18,479.46
             2676.06,486.08 2707.68,481.33 2730.05,467.33
             2768.05,443.69 2787.30,402.17 2783.42,352.28
             2780.67,317.01 2762.17,284.25 2734.43,265.24
             2724.80,258.74 2708.80,251.73 2698.30,249.61
             2686.56,247.23 2663.68,247.23 2652.31,249.61 Z
           M 2684.93,298.63
           C 2718.18,307.88 2737.18,343.77 2729.18,382.04
             2725.55,399.17 2714.80,415.05 2701.05,423.93
             2675.56,440.31 2636.81,434.31 2618.56,411.30
             2611.69,402.55 2608.94,396.79 2605.94,385.54
             2599.31,359.53 2605.56,332.14 2621.81,315.01
             2637.31,298.75 2662.18,292.38 2684.93,298.63 Z
           M 833.69,278.87
           C 833.69,278.87 833.69,486.46 833.69,486.46
             833.69,486.46 891.81,486.46 891.81,486.46
             891.81,486.46 949.93,486.46 949.93,486.46
             949.93,486.46 949.93,342.27 949.93,342.27
             949.93,263.11 949.43,179.95 948.68,157.57
             947.56,122.18 945.06,85.66 942.93,74.66
             942.93,74.66 942.18,71.28 942.18,71.28
             942.18,71.28 887.94,71.28 887.94,71.28
             887.94,71.28 833.69,71.28 833.69,71.28
             833.69,71.28 833.69,278.87 833.69,278.87 Z
           M 662.45,223.47
           C 662.45,361.28 662.70,379.79 664.95,417.68
             666.33,440.69 668.20,465.45 669.08,472.70
             669.08,472.70 670.58,485.83 670.58,485.83
             670.58,485.83 725.32,486.21 725.32,486.21
             725.32,486.21 779.94,486.46 779.94,486.46
             779.94,486.46 779.94,278.87 779.94,278.87
             779.94,278.87 779.94,71.28 779.94,71.28
             779.94,71.28 721.20,71.28 721.20,71.28
             721.20,71.28 662.45,71.28 662.45,71.28
             662.45,71.28 662.45,223.47 662.45,223.47 Z
           M 362.85,215.97
           C 363.22,374.16 362.97,368.66 370.72,395.54
             384.22,443.19 419.59,477.33 467.97,489.58
             484.21,493.71 498.84,495.21 522.71,495.21
             554.21,495.21 581.96,490.71 605.58,481.96
             614.33,478.58 638.70,466.70 642.83,463.70
             644.95,462.20 644.95,460.32 642.95,423.31
             641.83,401.92 640.70,384.41 640.58,384.16
             640.33,383.91 637.45,385.41 634.20,387.54
             622.70,394.54 606.83,401.42 594.33,404.80
             583.33,407.67 579.33,408.05 561.83,408.17
             547.09,408.17 539.59,407.67 533.46,406.05
             506.84,399.42 491.46,384.91 484.09,359.53
             482.09,352.65 481.84,341.27 481.47,211.59
             481.47,211.59 481.22,71.28 481.22,71.28
             481.22,71.28 421.72,71.28 421.72,71.28
             421.72,71.28 362.35,71.28 362.35,71.28
             362.35,71.28 362.85,215.97 362.85,215.97 Z
           M 56.25,278.87
           C 56.25,278.87 56.25,486.46 56.25,486.46
             56.25,486.46 115.62,486.46 115.62,486.46
             115.62,486.46 174.99,486.46 174.99,486.46
             174.99,486.46 174.99,346.65 174.99,346.65
             174.99,194.96 173.61,138.56 168.49,94.67
             168.49,94.67 165.86,71.28 165.86,71.28
             165.86,71.28 111.12,71.28 111.12,71.28
             111.12,71.28 56.25,71.28 56.25,71.28
             56.25,71.28 56.25,278.87 56.25,278.87 Z
           M 2219.21,63.90
           C 2179.22,66.53 2125.10,77.16 2102.10,86.91
             2102.10,86.91 2097.35,88.79 2097.35,88.79
             2097.35,88.79 2097.35,130.56 2097.35,130.56
             2097.35,130.56 2097.35,172.32 2097.35,172.32
             2097.35,172.32 2107.10,169.20 2107.10,169.20
             2153.09,154.82 2212.84,147.69 2259.09,151.19
             2311.83,155.19 2330.71,166.07 2338.58,197.08
             2340.96,206.21 2341.08,211.09 2341.08,289.37
             2341.08,289.37 2341.08,371.91 2341.08,371.91
             2341.08,371.91 2333.58,379.16 2333.58,379.16
             2306.96,405.05 2264.34,419.43 2220.46,417.30
             2181.47,415.43 2159.59,401.92 2153.59,376.16
             2151.84,368.28 2152.09,354.15 2154.22,346.02
             2159.47,325.89 2171.09,314.76 2193.22,308.63
             2202.34,306.13 2206.21,305.88 2260.21,305.38
             2260.21,305.38 2317.33,304.88 2317.33,304.88
             2317.33,304.88 2317.33,267.99 2317.33,267.99
             2317.33,267.99 2317.33,231.10 2317.33,231.10
             2317.33,231.10 2253.96,231.72 2253.96,231.72
             2184.84,232.35 2175.22,233.22 2148.09,239.98
             2125.60,245.73 2102.72,257.49 2086.85,271.49
             2070.97,285.50 2056.35,310.13 2050.85,332.02
             2048.35,341.90 2047.98,346.27 2048.10,367.66
             2048.23,388.54 2048.60,393.42 2050.85,402.05
             2063.10,446.94 2098.85,478.45 2152.09,491.09
             2163.34,493.71 2169.47,494.34 2191.22,494.84
             2228.71,495.84 2257.59,492.34 2283.96,483.83
             2299.83,478.70 2323.46,466.70 2335.46,457.70
             2347.20,448.94 2345.83,447.57 2349.33,471.33
             2349.33,471.33 2351.58,486.46 2351.58,486.46
             2351.58,486.46 2403.20,486.46 2403.20,486.46
             2403.20,486.46 2454.95,486.46 2454.95,486.46
             2454.95,486.46 2454.45,341.65 2454.45,341.65
             2453.95,186.20 2454.07,191.46 2447.32,166.82
             2444.32,155.57 2435.82,136.93 2429.70,127.93
             2396.58,79.41 2322.71,56.90 2219.21,63.90 Z
           M 1578.01,63.90
           C 1563.01,65.53 1548.26,68.65 1533.64,73.41
             1520.51,77.66 1495.14,89.16 1485.27,95.42
             1485.27,95.42 1479.89,98.79 1479.89,98.79
             1479.89,98.79 1485.02,105.42 1485.02,105.42
             1494.14,117.30 1506.14,146.69 1506.14,157.07
             1506.14,158.57 1506.64,160.19 1507.14,160.57
             1507.77,160.94 1512.27,159.57 1517.01,157.57
             1532.01,151.31 1540.89,149.81 1559.89,150.31
             1574.01,150.81 1578.14,151.44 1585.14,154.07
             1599.51,159.44 1606.63,166.82 1612.38,182.20
             1618.51,198.71 1618.63,200.84 1618.63,348.40
             1618.63,348.40 1618.63,486.46 1618.63,486.46
             1618.63,486.46 1674.25,486.46 1674.25,486.46
             1674.25,486.46 1730.00,486.46 1730.00,486.46
             1730.00,486.46 1729.50,344.90 1729.50,344.90
             1729.12,229.10 1728.75,201.59 1727.37,194.58
             1727.37,194.58 1725.62,186.08 1725.62,186.08
             1725.62,186.08 1730.50,181.70 1730.50,181.70
             1747.00,167.32 1760.50,159.57 1778.25,154.32
             1787.37,151.56 1792.49,150.94 1808.24,150.44
             1838.12,149.44 1855.62,154.57 1868.24,167.95
             1875.86,175.95 1879.11,182.08 1882.74,194.83
             1885.49,204.46 1885.49,204.96 1885.86,345.40
             1885.86,345.40 1886.24,486.46 1886.24,486.46
             1886.24,486.46 1944.23,486.46 1944.23,486.46
             1944.23,486.46 2002.35,486.46 2002.35,486.46
             2002.35,486.46 2002.35,339.02 2002.35,339.02
             2002.35,179.20 2002.23,177.08 1995.48,151.31
             1989.36,128.05 1974.48,103.17 1959.36,90.79
             1944.73,78.91 1923.24,69.78 1899.74,65.40
             1883.49,62.40 1839.99,62.40 1819.87,65.40
             1803.74,67.78 1786.12,72.16 1773.00,77.16
             1755.50,83.66 1727.75,98.67 1715.00,108.30
             1712.00,110.67 1709.13,112.55 1708.75,112.55
             1708.38,112.55 1706.00,109.42 1703.63,105.55
             1692.88,88.29 1670.63,72.78 1649.26,67.53
             1629.88,62.78 1601.88,61.40 1578.01,63.90 Z
           M 1063.67,63.90
           C 1048.67,65.40 1030.55,69.40 1015.80,74.53
             1001.18,79.53 972.55,93.41 971.55,95.79
             971.18,96.79 971.80,113.92 972.93,134.06
             974.05,154.19 974.93,171.45 974.93,172.32
             974.93,173.20 977.93,171.82 982.18,169.07
             1001.68,155.82 1019.43,150.06 1041.05,150.06
             1071.30,150.06 1087.05,157.94 1096.05,177.58
             1104.42,195.83 1104.17,189.58 1104.54,345.40
             1104.54,345.40 1105.04,486.46 1105.04,486.46
             1105.04,486.46 1160.04,486.46 1160.04,486.46
             1160.04,486.46 1215.04,486.46 1215.04,486.46
             1215.04,486.46 1214.54,342.27 1214.54,342.27
             1214.29,225.85 1213.91,197.21 1212.54,192.83
             1212.54,192.83 1210.79,187.46 1210.79,187.46
             1210.79,187.46 1216.29,181.83 1216.29,181.83
             1224.29,173.57 1241.91,162.19 1253.16,157.82
             1267.91,152.19 1280.41,150.06 1298.53,150.06
             1340.78,150.19 1361.28,164.32 1369.40,198.84
             1371.40,207.46 1371.65,219.84 1372.03,347.27
             1372.03,347.27 1372.53,486.46 1372.53,486.46
             1372.53,486.46 1430.52,486.46 1430.52,486.46
             1430.52,486.46 1488.64,486.46 1488.64,486.46
             1488.64,486.46 1488.64,344.77 1488.64,344.77
             1488.64,173.20 1488.14,165.45 1477.14,137.56
             1470.77,121.18 1463.27,109.67 1451.14,97.42
             1440.77,87.04 1437.65,84.66 1426.40,79.03
             1412.02,71.78 1402.02,68.53 1385.52,65.65
             1350.15,59.40 1296.91,63.53 1264.16,75.16
             1242.91,82.66 1218.04,95.67 1201.29,107.92
             1201.29,107.92 1194.41,112.92 1194.41,112.92
             1194.41,112.92 1192.54,110.05 1192.54,110.05
             1173.16,80.53 1151.17,67.90 1112.42,63.78
             1098.55,62.40 1078.80,62.40 1063.67,63.90 Z
           M 306.10,65.03
           C 272.86,70.91 232.73,83.41 203.49,97.17
             203.49,97.17 193.74,101.67 193.74,101.67
             193.74,101.67 193.74,107.42 193.74,107.42
             193.74,114.42 197.61,184.33 198.11,184.83
             198.24,184.95 209.61,181.45 223.23,176.83
             250.73,167.70 282.10,159.44 306.60,154.94
             306.60,154.94 322.48,152.07 322.48,152.07
             322.48,152.07 322.48,107.30 322.48,107.30
             322.48,72.28 322.10,62.53 320.98,62.65
             320.10,62.65 313.35,63.78 306.10,65.03 Z"
    />
  </svg>
);

export default OHIFLogo;
